module.exports = __webpack_public_path__ + "static/assets/amazon-logo.7b789df.png";